module.exports = __webpack_public_path__ + "img/鼎锐联设备管理软件.dbfa4a17.png";